import { render, staticRenderFns } from "./BreadcrumComponent.vue?vue&type=template&id=976b9fe4&scoped=true"
import script from "./BreadcrumComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b9fe4",
  null
  
)

export default component.exports